const cookie = require('cookie_js').cookie;
const platform = require('platform');
const config = require('./config.yaml');
const text = require('./text.yaml')[templateVars.lang];

$('document').ready(function () {
	var oldBrowserCookie = cookie('shown_old_browser');
	var mobileAppCookie = cookie('shown_mobile_app');
	var lawCookie = cookie('shown_cookies_law');

	if (oldBrowserCookie != 'true' && config.browsers[platform.name] !== undefined) {
		const lang = templateVars.lang;
		var openAnimation = {height: 'toggle'};
		var closeAnimation = {height: 'toggle'};
		const versionRequire = Number(config.browsers[platform.name].version);
		const clientVersion = Number(platform.version.match(/^([0-9]+.[0-9]+|$)/)[0]);

		if (config.isStatic) {
			openAnimation = {height: 'toggle'};
			closeAnimation = {height: 'toggle'};
		}

		var closeBtn = false;
		var closeWith = '';

		if (config.closable) {
			closeBtn = [
				{
					addClass: 'noty-close',
					text: '',
					onClick: function ($noty) {
						cookie.set('shown_old_browser', 'true', {path: '/', expires: 365});

						$noty.close();

						if (config.isStatic && !this.parents('.noty_container--fixed').length) {
							$('body').velocity({marginTop: 0}, {duration: 400});
						}
					}
				}
			];
			closeWith = 'button';
		}

		if (clientVersion < versionRequire) {
			var oldBrowserNotify = noty({
				layout: 'inline',
				type: 'information',
				text: text.message,
				theme: 'old-browser noty_container noty_container--centered-content'
				+ (config.isStatic && ((oldBrowserCookie != 'first' && oldBrowserCookie != 'second' && mobileAppCookie != 'true') || (lawCookie == 'true' || !lawCookie)) ? ' noty_container--static' : ' noty_container--fixed')
				+ ((oldBrowserCookie == 'first' || oldBrowserCookie == 'second') && (lawCookie != 'true' && lawCookie) ? ' noty_container--bottom' : ''),
				template: `<div class="noty_message">
					<span class="noty_text"></span>
				</div>`,
				buttons: closeBtn,
				animation: {
					open: openAnimation,
					close: closeAnimation,
					easing: 'swing',
					speed: 400
				},
				closeWith: [closeWith],
				callback: {
					onShow: function () {
						if ($('.noty_inline_layout_container .noty_container').length == 1 && config.isStatic) {
							var $body = $('body');
							var notyHeight = $('.old-browser').height();

							$body.css('margin-top', '1px');

							$body.velocity({marginTop: notyHeight}, {duration: 445});
						}

						if (oldBrowserCookie == undefined) {
							cookie.set('shown_old_browser', 'first', {path: '/', expires: 365});
						} else {
							cookie.set('shown_old_browser', 'second', {path: '/', expires: 365});
						}
					}
				}
			});
		}
	}
});



// WEBPACK FOOTER //
// ./temp/components/old-browser/index.js